import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import { IClub } from '../../../store/player/clubs/store';

export interface IProps {
  club: IClub;
}

const ClubBasicInfo = ({ club }: IProps) => {
  return (
    <div className="club-basic-info-container">
      {club && (
        <div>
          <h3 className="club-info-body__subtitle">HOME COURSE</h3>
          <p>{club.course && club.course.name}</p>
          <p>{club.course && club.course.address}</p>

          <h3 className="club-info-body__subtitle">CONTACT INFORMATION</h3>
          <p>{club.email}</p>

          <h3 className="club-info-body__subtitle">About The Club</h3>
          <ReactMarkdown source={club.description} className="markdown" />
        </div>
      )}
    </div>
  );
};

export default ClubBasicInfo;
